import React from 'react'
import backgrounds from "../../backgrounds.json";
import "./backgrounds.scss"

const BackgroundSelector = ({ handleTemplate }) => {

  return (
    <div className="backgrounds">
      {backgrounds.map(background => (
        <div className="background"
          key={background.id}
            onClick={() => handleTemplate(background.src)}
          >
          <img src={background.src} alt={background.name}
          />
        </div>
      ))}
    </div>
  )
}

export default BackgroundSelector
